<template>
  <el-container>
    <el-main>
      <div class="jumbotron">
        <h1 class="display-4">{{ $t("forbidden403.title") }}</h1>
        <p class="lead">{{ $t("forbidden403.text") }}</p>
        <hr class="my-4" />
        <router-link
          class="btn btn-primar btn-lgy"
          :to="{ name: 'dashboard' }"
          >{{ $t("forbidden403.link") }}</router-link
        >
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: this.$t('forbidden403.metaTitle')
    }
  }
}
</script>
